import styled from 'styled-components'

export const StyledGroundingWithVIN = styled.div`
  .spinner-row {
    display: flex;
    align-content: center;
    justify-content: center;
  }
  .form-control:focus {
    border-color: ${({ theme }) => {
      return theme.carousel.buttonBorder
    }}!important;
    outline: 0;
    box-shadow: ${({ theme }) => {
      return '0 0 0 0' + theme.carousel.buttonBorder
    }}!important;
  }
`
